import axios from "axios";
export let apiInstance = axios;
import { getAccessToken } from "../utils";
import { AYALA_NEWS_RSS, PUBLISHED } from "../constants"
import { ACCESS_TOKEN_DATA_KEY } from "../constants";

const getAuthorization = (): string => {
  return "Basic " + window.btoa(process.env.REACT_APP_CLIENT_ID! + ":" + process.env.REACT_APP_CLIENT_SECRET!);
};

export const createApiInstance = (): void => {
  const env: string = process.env.REACT_APP_BACKEND_ENV!;
  let baseURL = "";

  switch (env) {
    case "prod":
      baseURL = process.env.REACT_APP_BACKEND_BASE_PATH_PROD!;
      break;
    case "dev":
      baseURL = process.env.REACT_APP_BACKEND_BASE_PATH_DEV!;
      break;
    case "test":
    case "uat":
      baseURL = process.env.REACT_APP_BACKEND_BASE_PATH_TEST!;
      break;
    default:
      baseURL = process.env.REACT_APP_BACKEND_BASE_PATH_LOCAL!;
      break;
  }

  //@ts-ignore
  apiInstance = axios.create({
    baseURL,
    headers: {
      Authorization: getAuthorization(),
    },
  });

  axios.interceptors.request.use(
    (config) => {
      config.baseURL = baseURL;

      config.headers = {
        Authorization: getAuthorization()
      };

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const {config, message} = error;

        if(error?.response.status !== 200 && !config?.sent) {
          const result = await refreshToken();

          if(result?.access_token) {
            config.headers = {
              ...config.headers,
              authorization: `Bearer ${result?.access_token}`
            };
            Promise.reject(error)
          }
          config.sent = true;
          config.retry = true;

          return axios.request(config);
        }
        return Promise.reject(error);
    }
  );

};

const scope = "openid+email+profile+offline_access";

export const createToken = async (code: string) => {
  const codeVerifier = localStorage.getItem("code_verifier");
  const state = localStorage.getItem('state');

  try {
    const data = {
      code,
      redirect_uri: process.env.REACT_APP_REDIRECT_URI,
      code_verifier: codeVerifier,
      scope: scope,
      state: state,
    };

    const response = await apiInstance.post("/auth/token/get", data, {
      headers: {
        Authorization: getAuthorization(),
      },
    });

    const result = response.data;

    if (result) {
      const resData = result.data;
      const accessToken = resData.access_token;
      await storeInfo(accessToken)

      return resData;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const refreshToken = async () => {
const scope = "openid+email+profile+offline_access";
try{
  const data = {
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    scope: scope,
    refresh_token: localStorage.getItem("refreshToken"),
  }
  const response = await apiInstance.post("/auth/token/refresh", data, {
    headers: {
      Authorization: getAuthorization(),
    },
  });

  const result = response.data;

  if (result) {
    const resData = result.data;
    console.log(resData)

    if(!localStorage.getItem("at_user_info")
    || !localStorage.getItem("user_info")
    || !localStorage.getItem("assist_user_access")
    || !localStorage.getItem("user_access")){
      storeInfo(response.data.data.access_token)
    }

    return resData;
  }
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveStoreInfo = async () => {
  try {
    const payload = {
        "at_user_info": localStorage.getItem("at_user_info"),
        "assist_user_access": localStorage.getItem("assist_user_access"),
        "user_info": localStorage.getItem("user_info"),
        "user_access": localStorage.getItem("user_access"),
        "access_token_data_key": localStorage.getItem(ACCESS_TOKEN_DATA_KEY),
        "refresh_token": localStorage.getItem("refreshToken")
    }

    const response = await apiInstance.post(
      `/auth/save-store-info`, {encryptedStoreInfo:JSON.stringify(payload)}
    );

    const result = response?.data;

    return result;

  } catch (e) {
    console.error(e);
    return null;
  }
};

export const storeInfo = async (accessToken: string) => {
  try {
    if (!accessToken) {
      return;
    }

    const response = await apiInstance.get(
      `/auth/store-info?access_token=${accessToken}`
    );

    const result = response?.data;

    localStorage.setItem("assist_user_access", result.assist_user_access)
    localStorage.setItem("user_access", result.user_access)
    localStorage.setItem("at_user_info", result.at_user_info)
    localStorage.setItem("user_info", result.user_info)

    return result;

  } catch (e) {
    console.error(e);
    return null;
  }
};

export const updateStoreInfoByType = async (accessToken: string, type) => {
  try {
    if (!accessToken) {
      return;
    }

    let response;

    switch (type){
      case "assist_user_access":
        response = await apiInstance.get(
          `/auth/update-store-info-by-type?access_token=${accessToken}&type=${type}`
        );
        localStorage.setItem("assist_user_access", response.data)
        break;
      case "user_access":
        response = await apiInstance.get(
          `/auth/update-store-info-by-type?access_token=${accessToken}&type=${type}`
        );
        localStorage.setItem("user_access", response.data)
        break;
      case "at_user_info":
        response = await apiInstance.get(
          `/auth/update-store-info-by-type?access_token=${accessToken}&type=${type}`
        );
        localStorage.setItem("at_user_info", response.data)
        break;
      case "user_info":
        response = await apiInstance.get(
          `/auth/update-store-info-by-type?access_token=${accessToken}&type=${type}`
        );
        localStorage.setItem("user_info", response.data)
        break;

      default:
        console.log("No type given")
    }

    return response;

  } catch (e) {
    console.error(e);
    return null;
  }
};


export const getUserInfo = async (accessToken: string) => {
  try {
    if (!accessToken) {
      return;
    }

    const response = await apiInstance.get(
      `/auth/userinfo?access_token=${accessToken}`
    );

    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const introspect = async (accessToken: string) => {
  const storedData = localStorage.getItem(ACCESS_TOKEN_DATA_KEY);

  if (!storedData) {
    return null;
  }
  const accessTokenData = JSON.parse(storedData);
  try {
    if (!accessToken) {
      return;
    }

    const tokenTypeHint = "access_token";
    const data = {
      token: accessToken,
      token_type_hint: tokenTypeHint,
    };

    const response = await apiInstance.post("/auth/introspect", data);
    const result = response?.data;

    if (result) {
      const data = result.data;
      if (!data.active) {
          refreshToken().then((response) => {
          console.log("Response : "+response?.error);
          if (!response?.error) {
            localStorage.setItem(
              ACCESS_TOKEN_DATA_KEY,
              JSON.stringify({
                accessToken: response?.access_token,
                idToken: response?.id_token,
                tokenType: response?.token_type,
                expiresIn: response?.expires_in,
                refreshToken: response?.refresh_token,
              })
            );
            localStorage.setItem("refreshToken", response?.refresh_token);
            storeInfo(response?.access_token)
            introspect(response?.access_token);
          }
          
        });
        
      }
     
    }


    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

//

//

import Parser from 'rss-parser';
export const getAyalaNews = async () => {
  
  try {
    const response = await fetch(AYALA_NEWS_RSS);
    const rssText = await response.text();

    const parser = new Parser();

    const feed = await parser.parseString(rssText);
    return feed.items;
  } catch (e) { console.log(e) }

  return []
}

export const hasAcceptedTerms = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }

    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/terms/has-accepted", payload, {headers});
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const getTerms = async () => {
  try {
    const response = await apiInstance.get("/terms/get");
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export const getFAQs = async () => {
  try {
    const response = await apiInstance.get("/faqs/get");
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}


export const acceptTerms = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }
    
    const response = await apiInstance.post("/terms/accept", payload, {headers});
    const result = response?.data;
    
    await updateStoreInfoByType(accessToken, "at_user_info")
    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const hasAcceptedPrivacy = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }

    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/privacy-policy/has-accepted", payload, {headers});
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const getPrivacyPolicy = async () => {
  try {
    const response = await apiInstance.get("/privacy-policy/get");
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export const acceptPrivacyPolicy = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }
    
    const response = await apiInstance.post("/privacy-policy/accept", payload, {headers});
    const result = response?.data;
    
    await updateStoreInfoByType(accessToken, "at_user_info")
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getAssistTerms = async () => {
  try {
    const response = await apiInstance.get("/assist-terms/get");
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
}

export const homePageCheck = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }

    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/homepage/checker", payload, {headers});
    const result = response?.data;
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const hasAcceptedAllTerms = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }

    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/all-terms/has-accepted", payload, {headers});
    const result = response?.data;
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const acceptAllTerms = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }
    
    const response = await apiInstance.post("/all-terms/accept", payload, {headers});
    const result = response?.data;
    
    await updateStoreInfoByType(accessToken, "at_user_info")
    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const acceptWAATerms = async () => {
  try {

    
    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }
    
    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/waa-terms/accept", payload, {headers});
    const result = response?.data;
    // console.log("ACCEPT WAA TERMS : "+JSON.stringify(result));
    await updateStoreInfoByType(accessToken, "at_user_info")
    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const acceptAssistTerms = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }
    
    const response = await apiInstance.post("/assist-terms/accept", payload, {headers});
    const result = response?.data;
    
    await updateStoreInfoByType(accessToken, "at_user_info")
    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const incrementLogin = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }
    const response = await apiInstance.post("/options/increment-login", null, {headers});
    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getPosts = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/posts/all", payload, {headers});
    const result = response?.data?.data;
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getReadItems = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/posts/read-items", payload, {headers});
    
    try {
      const metaValue = response?.data?.length ? response?.data?.shift()?.meta_value || false : false;
      if(!metaValue) {
        return [];
      }

      return JSON.parse(metaValue);
    }
    catch (e){
      console.log(e);
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const markAsRead = async (pid, source) => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }
    
    const payload = {
      "at_user_info": localStorage.getItem("at_user_info"),
      "pid": pid,
      "source": source
    }

    const response = await apiInstance.post("/posts/mark-as-read", payload, {headers});

    const result = response?.data;

    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const sendGlobeSMSCode = async (code) => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    const payload = {
      "at_user_info": localStorage.getItem("at_user_info")
    }

    const response = await apiInstance.post("/notification/generate-access-token", payload, {headers});
    
    const result = response?.data;
    console.log("sendGlobeSMSCode : "+result);
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getAsuiteApps = async () => {
  try {

    const response = await apiInstance.get(`/apps/list?limit=1000&filters[status]=${PUBLISHED}`);
    
    const result = response?.data;
    
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const logAppClicks = async (app_id) => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }
    const data = {
      app_id
    };
    const response = await apiInstance.post("/app-clicks/click", data, {headers});
    
    const result = response?.data;
    
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getEmergencyList = async () => {
  try {

    const accessToken = getAccessToken();
    if(!accessToken) {
      return false;
    }
    const headers = {
      'access-token': accessToken
    }

    // const at_user_info = JSON.parse(localStorage.getItem("at_user_info") || "");

    const url = "/user-status/get-by-user-id";
    // const response = await apiInstance.get(`${url}?at_user_info=${at_user_info}`, { headers });
    const response = await apiInstance.get(`${url}`, { headers });

    const result = response?.data?.data;
    
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getImageBanner = async () => {
  try {

    const response = await apiInstance.get(`/banner/latest`);
    const result = response?.data;
    return result;
  } catch (e) {
    console.error(e);
    return false;
  }
};
